import { render, staticRenderFns } from "./WorkflowInstalacaoDetalhesComponent.vue?vue&type=template&id=6410a3b8"
import script from "./WorkflowInstalacaoDetalhesComponent.vue?vue&type=script&lang=js"
export * from "./WorkflowInstalacaoDetalhesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports